module.exports = __webpack_public_path__ + "img/가디언.66d505ac.png";